import { motion } from 'framer-motion';

interface AnimatedBackgroundProps {
  nodeCount?: number;
  opacity?: number;
}

export function AnimatedBackground({ nodeCount = 20, opacity = 0.2 }: AnimatedBackgroundProps) {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ opacity, zIndex: 0 }}>
      {[...Array(nodeCount)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute h-2 w-2 rounded-full bg-primary"
          initial={{
            x: Math.random() * (typeof window !== 'undefined' ? window.innerWidth : 1000),
            y: Math.random() * (typeof window !== 'undefined' ? window.innerHeight : 1000),
          }}
          animate={{
            x: Math.random() * (typeof window !== 'undefined' ? window.innerWidth : 1000),
            y: Math.random() * (typeof window !== 'undefined' ? window.innerHeight : 1000),
          }}
          transition={{
            duration: 20 + Math.random() * 10,
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />
      ))}
    </div>
  );
}
